import { useDispatch } from "react-redux"
import { createFacebookAdCreative } from "@services/facebookAdCreatives/createCreative"
import {
  createAdCreativeLoading,
  createAdCreativeSuccess,
  createAdCreativeFailure,
} from "@redux/slices/facebookAdCreativesSlice.js"
import useAdPostAttempts from "./useAdPostAttempts"
import useAdSets from "./useAdSets"

//const userId = import.meta.env.VITE_USER_ID
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const useFacebookAdCreatives = () => {
  const dispatch = useDispatch()
  const { handleCreateAdPostAttempt } = useAdPostAttempts()
  const { handleDuplicateAdSetForAdPerAdset } = useAdSets()
  const userId = localStorage.getItem("userId")
  const isOneAdPerAdSet = localStorage.getItem("oneAdPerAdSet") === "true";

  const handleCreateAdCreative = async (
    adAccountId,
    data,
    defaultValues,
  ) => {
    try {
      // Add random delay
      const randomDelay = Math.floor(Math.random() * 15000) + 5000; // 5000-20000ms
      await delay(randomDelay);
      let targetAdSetId = defaultValues.targetAdSetId;
      dispatch(createAdCreativeLoading());
      console.log("Sending data to createFacebookAdCreative:", data);
      const response = await createFacebookAdCreative(adAccountId, data);
      console.log("Response from createFacebookAdCreative:", response.data);
      if (!response?.data?.id) {
        throw new Error("Failed to create Facebook AdCreative");
      }
      dispatch(createAdCreativeSuccess(response.data));
      return response.data;
      
    } catch (error) {
      await handleCreateAdPostAttempt({
        creative_details: {
          req_payload: data,
          adAccountId: adAccountId,
          response: "AdCreativeCallFailed" + error.message || null,
        },
        userId: userId,
      })
      console.error("AdCreative creation failed:", error)
      dispatch(createAdCreativeFailure(error?.response?.data || error.message))
    }
  }

  // Add new function to handle post ad
  const handlePostAd = async (
    adAccountId,
    adCreativeId,
    ad,
    defaultValues,
    handleCreateFacebookAd
  ) => {
    const randomDelay = Math.floor(Math.random() * 15000) + 5000; // 5000-20000ms
    try {
      let targetAdSetId = defaultValues.targetAdSetId;

      if (localStorage.getItem("oneAdPerAdSet") === "true") {
        await delay(randomDelay);
        targetAdSetId = await handleDuplicateAdSetForAdPerAdset(
          defaultValues.targetAdSetId,
          ad.name
        );
      }

      await delay(randomDelay);
      // const responseFBAdPost = await handleCreateFacebookAd(adAccountId, {
      //   name: ad.name,
      //   adset_id: targetAdSetId,
      //   creative: {
      //     creative_id: adCreativeId,
      //   },
      //   status: "PAUSED",
      // });
      const responseFBAdPost =  {"id": "123dummy"};
      console.log("Response from handleCreateFacebookAd in handlePostAd:", responseFBAdPost);

      if (!responseFBAdPost?.id) {
        throw new Error("Failed to POST Facebook Ad");
      }
      return responseFBAdPost;
    } catch (error) {
      await handleCreateAdPostAttempt({
        creative_details: {
          req_payload: {
            "ad": ad, 
            "targetAdSet": defaultValues.targetAdSetId,
            "adCreativeId": adCreativeId,
          },
          adAccountId: adAccountId,
          response: "PostAdFailed" + error.message || null,
        },
        userId: userId,
      });
      console.error("Failed to create ad per adset:", error);
      throw error;
    }
  };

  return {
    handleCreateAdCreative, handlePostAd
  }
}

export default useFacebookAdCreatives
